<script setup lang="ts">
import { useVModel } from '@vueuse/core'
import { dropoffOptions } from "@lib/zod/userAddressSchema";
import DropoffIcon from './DropoffIcon.vue';
// import {
//     Collapsible,
//     CollapsibleContent,
//     CollapsibleTrigger,
// } from '@/components/ui/collapsible';
// import { ChevronDown } from 'lucide-vue-next';
// import { ref } from 'vue';

const props = defineProps<{
    modelValue?: (typeof dropoffOptions)[number],
}>()

const emits = defineEmits<{
    (e: 'update:modelValue', payload: (typeof dropoffOptions)[number] | undefined): void
}>()

const modelValue = useVModel(props, 'modelValue', emits, {
    passive: true,
    defaultValue: undefined,
    deep: props.modelValue ? false : true,
})

// const isOpen = ref(false);

const selectOption = (option: typeof dropoffOptions[number]) => {
    if (modelValue.value === option) {
        // deselect
        modelValue.value = undefined;
    } else {
        modelValue.value = option;
    }
    // isOpen.value = false;
};
</script>

<template>
    <!-- <Collapsible v-model:open="isOpen"
                 class="border w-full max-w-full">
        <CollapsibleTrigger
                            class="w-full px-4 py-3 flex items-center justify-between gap-3 hover:bg-muted/50 cursor-pointer">
            <div class="flex items-center gap-2 text-sm">
                <div v-if="modelValue"
                     class="mr-8">
                    <DropoffIcon :option="modelValue" />
                </div>
                <span v-if="!modelValue"
                      class="text-muted-foreground">Preference (optional)</span>
            </div>
            <ChevronDown class="h-4 w-4 flex-shrink-0 text-muted-foreground transition-transform duration-200"
                         :class="{ 'rotate-180': isOpen }" />
        </CollapsibleTrigger>
        <CollapsibleContent> -->
    <div class="border-t p-3 overflow-hidden">
        <div class="flex overflow-x-auto overflow-y-hidden no-scrollbar gap-2"
             style="width: 0; min-width: 100%;">
            <button v-for="option in dropoffOptions"
                    :key="option"
                    type="button"
                    class="cursor-pointer flex flex-col items-center gap-2 rounded-lg border p-3 min-w-[110px] snap-start transition-colors hover:bg-accent/50"
                    :class="modelValue === option
                        ? 'border-primary bg-primary/10 dark:bg-primary/20'
                        : 'border-muted'"
                    @click="selectOption(option)">
                <DropoffIcon :option="option" />
            </button>
        </div>
    </div>
    <!-- </CollapsibleContent> -->
    <!-- </Collapsible> -->
</template>
